import { Components, Inputs } from "@thisgorilla/primate-ds";
import { useState } from "react";
import styled, { useTheme } from "styled-components";
import { FlexColumn, FlexRow } from "../../Styles";

const Snippet = () => {
  const { typography, Color } = useTheme();
  const [isChecked, setIsChecked] = useState(false);
  const [isSnippetShare, setIsSnippetShare] = useState(false);

  return (
    <SnippetContainer>
      {isChecked && (
        <AlignCenter $gapInPx={0}>
          <Components.Text
            text="Do you want to share an audio snippet?"
            style={{ tokenStyle: typography.Body.S }}
            lineHeight="line-height-100"
            color={Color.text["text-emphasize-brand-bolder"].value}
          />
          <Inputs.Toggle
            checked={isSnippetShare}
            setChecked={setIsSnippetShare}
            offLabel=""
            onLabel=""
            disabled={false}
          />
        </AlignCenter>
      )}
      <AlignCenter $gapInPx={8}>
        <Inputs.Checkbox
          checked={isChecked}
          onChangeHandler={() => {
            setIsChecked(!isChecked);
          }}
          label="Start at"
        />
        <FlexRow>
          <Components.Text
            text={isSnippetShare ? "05:30" : "00:00"}
            style={{ tokenStyle: typography.Body.M }}
            lineHeight="line-height-100"
            color={
              isSnippetShare
                ? Color.text["text-emphasize-brand"].value
                : Color.text["text-placeholder"].value
            }
          />
          {isSnippetShare && (
            <>
              <Components.Text
                text={"End at"}
                style={{ tokenStyle: typography.Body.M }}
                lineHeight="line-height-100"
              />
              <Components.Text
                text={"07:47"}
                style={{ tokenStyle: typography.Body.M }}
                lineHeight="line-height-100"
                color={Color.text["text-emphasize-brand"].value}
              />
            </>
          )}
        </FlexRow>
      </AlignCenter>
    </SnippetContainer>
  );
};

export default Snippet;

const SnippetContainer = styled(FlexColumn)`
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-1"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  background-color: ${({ theme }) =>
    theme.Color.elevation.surface["surface-tertiary"].value};
`;

const AlignCenter = styled(FlexRow)`
  align-items: center;
`;
